import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';
import { ResellerUsersResponse } from '@utils/types/resellers/reseller-all-users.ts';

export const useGetResellerAllUsers = () => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;
  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchCustomers = async () => {
    // pass server-side params to GET_URL_NEW
    const { resellerAllUsers } = GET_URL_NEW({
      offset,
      limit,
      sort,
      direction,
      q
    });
    const url = resellerAllUsers; // already built with the params
    const { data } = await Axios.get<ResellerUsersResponse>(url);
    return data;
  };

  return useQuery<ResellerUsersResponse, AxiosError<BaseError>>(
    ['resellerAllUsers', offset, limit, q, sort, direction],
    fetchCustomers,
    { keepPreviousData: true }
  );
};
